import { Provider } from '@converge/graphql';

export interface IAddressProps {
  __typename?: 'Address' | undefined;
  uuid: string;
  street1?: string | null | undefined;
  street2?: string | null | undefined;
  city?: string | null | undefined;
  type?: string | null | undefined;
  postalCode?: string | null | undefined;
  source?: Provider | null | undefined;
  primary: boolean;
  regions: {
    __typename?: 'RegionEdges' | undefined;
    edges: {
      __typename?: 'RegionEdge' | undefined;
      node: {
        __typename?: 'Region' | undefined;
        uuid?: string | null | undefined;
        name?: string | null | undefined;
      };
    }[];
  };
  countries: {
    __typename?: 'CountryEdges' | undefined;
    edges: {
      __typename?: 'CountryEdge' | undefined;
      node: {
        __typename?: 'Country' | undefined;
        uuid?: string | null | undefined;
        name?: string | null | undefined;
      };
    }[];
  };
}

export const Address = ({
  street1,
  street2,
  city,
  regions: {
    edges: [region],
  },
  postalCode,
}: IAddressProps) => {
  return (
    <>
      {street1}
      <br />
      {street2 && (
        <>
          {street2}
          <br />
        </>
      )}
      {city}, {region?.node.name} {postalCode}
    </>
  );
};
